import {createSharedValueKey, useSharedValue} from '@epic-core/hooks';
import {useCallback} from 'react';
import {CreatorsFeedItemProps} from './CreatorFeed.organism';

export const activeCreatorKey = createSharedValueKey<string>('activeCreatorKey', '');

interface CreatorFeedRes {
    activeCreator: string;
    setActiveCreator: (string) => void;
}

export const useActiveCreator = (): CreatorFeedRes => {
    const [activeCreator, setActiveCreator] = useSharedValue(activeCreatorKey);

    return {
        activeCreator,
        setActiveCreator
    };
};

export const activeDetailCardKey = createSharedValueKey<number>('activeDetailCardKey', 0);

interface CreatorFeedActiveDetailCardRes {
    activeDetailCard: number;
    setActiveDetailCard: (n: number) => void;
}

export const useActiveDetailCard = (): CreatorFeedActiveDetailCardRes => {
    const [activeDetailCard, setActiveDetailCard] = useSharedValue<number>(activeDetailCardKey);

    return {
        activeDetailCard,
        setActiveDetailCard
    };
};

interface NextCreativeFeedDetailRes {
    activeIndex: number | undefined;
    next: () => void;
    prev: () => void;
    prevDisabled: boolean;
    nextDisabled: boolean;
}

export const useNextCreativeFeedDetail = (
    cards: CreatorsFeedItemProps[]
): NextCreativeFeedDetailRes => {
    const {activeCreator, setActiveCreator} = useActiveCreator();
    const {setActiveDetailCard} = useActiveDetailCard();

    let activeIndex;
    for (let i = 0; i < cards.length; i++) {
        const card = cards[i];
        if (card.title && card.title === activeCreator) {
            activeIndex = i;
            break;
        }
    }

    const prevDisabled = activeIndex === 0;
    const nextDisabled = activeIndex >= cards.length - 1;

    const next = useCallback(() => {
        if (activeIndex >= 0 && activeIndex < cards.length - 1) {
            const nextCard = cards[activeIndex + 1];
            if (nextCard && nextCard.title) {
                setActiveDetailCard(0);
                setActiveCreator(nextCard.title);
            }
        }
    }, [cards, activeIndex, setActiveCreator]);

    const prev = useCallback(() => {
        if (activeIndex > 0 && activeIndex <= cards.length - 1) {
            const prevCard = cards[activeIndex - 1];
            if (prevCard && prevCard.title) {
                setActiveDetailCard(0);
                setActiveCreator(prevCard.title);
            }
        }
    }, [cards, activeIndex, setActiveCreator]);

    return {
        activeIndex,
        next,
        prev,
        nextDisabled,
        prevDisabled
    };
};
